<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Notificaciones</h4>
            <div class="small text-muted">Panel de control de todas las notificaciones disparadas</div>
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col lg="9">
          <b-row>
            <b-col md="12">
              <Widget :configWidget="configWidget" reference="bar_notifications_months" :hasAccess="configWidget.elements.barNotificationsMonths" />                            
            </b-col>
            <b-col sm="12" md="6" lg="4">
              <Widget :configWidget="configWidget" reference="list_type_notifications_status" :hasAccess="configWidget.elements.listTypeNotificationsStatus" />                            
            </b-col>
            <b-col sm="12" md="12" lg="8">
              <Widget :configWidget="configWidget" reference="list_last_notifications_today" :hasAccess="configWidget.elements.listLastNotificationsToday" />
            </b-col>          
          </b-row>
        </b-col>
        <b-col lg="3">
          <b-list-group>
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openConfigurations()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Configuración</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Configuración de todos los tipos de notificación
              </p>
            </b-list-group-item>
          </b-list-group>
          <b-list-group class="mt-2">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openManuelSend()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Envío Manual</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Envío manual de notificaciones a usuarios
              </p>
            </b-list-group-item>
          </b-list-group>      
        </b-col>        
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'

  export default {
    components: {
      Widget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.NOTIFICACIONES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.NOTIFICACIONES,
          profile_id: Profiles.PERSONAL,
          elements: { 
            listTypeNotificationsStatus: true,
            listLastNotificationsToday: true,
            barNotificationsMonths: true,
          }
        },
        primaryColor: '',
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      /* Configurar permisos de los widgets */
      this.configWidget.elements.listTypeNotificationsStatus = Helper.hasAccessWidget(this.configWidget, 'list_type_notifications_status')
      this.configWidget.elements.listLastNotificationsToday = Helper.hasAccessWidget(this.configWidget, 'list_last_notifications_today')
      this.configWidget.elements.barNotificationsMonths = Helper.hasAccessWidget(this.configWidget, 'bar_notifications_months')
      /* Fin configuracion */
    },
    mounted() {
      this.setup()
    }, 
    methods: {
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      }, 
      openConfigurations() {
        this.$router.push({ name: 'NotificationsStaffConfigurations' })
      },    
      openManuelSend() {
        this.$router.push({ name: 'NotificationsStaffManualSend' })
      }
    }    
   
  }
</script>

<style>

</style>
